import React, { useEffect } from 'react'
import {
  Wizard,
  Tooltip,
  SpacingVertical,
  SPACING_24,
  Loading,
  ToastContainer
} from 'mailup-web-components'
import PageContainer from 'Components/PageContainer'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'
import { initCallback, resetCallback } from './recoil/callbacks/callbacks'
import Header from './components/Header'
import { useIntl } from 'react-intl'
import { pageState, wizardEnableStep2State } from './recoil/states/page'
import WizardStep1 from './components/WizardStep1'
import WizardStep2 from './components/WizardStep2'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { ModalFilterDetails } from './components/ModalFilterDetails'

const RcsSending = () => {
  const intl = useIntl()

  const { wizardStep, loading, backToStep1Disable } = useRecoilValue(pageState)
  const setPageState = useSetRecoilState(pageState)
  const resetState = useRecoilCallback(resetCallback, [])
  const enableStep2 = useRecoilValue(wizardEnableStep2State)
  const init = useRecoilCallback(initCallback, [])
  const { idMessage } = useParams()

  useEffect(() => {
    init(parseInt(idMessage))
    return () => {
      resetState()
    }
  }, [])

  const options = [
    {
      label: intl.formatMessage({ id: 'Load.Rcs.WizardStep1' }),
      value: 1,
      enabled: !backToStep1Disable
    },
    {
      label: intl.formatMessage({ id: 'Load.Rcs.WizardStep2' }),
      value: 2,
      enabled: enableStep2
    }
  ]

  const changeWizardStep = step => {
    setPageState(prev => ({
      ...prev,
      wizardStep: step
    }))
  }

  return (
    <>
      <Tooltip />
      <ModalFilterDetails />
      <Header />
      <ToastContainer />
      <Loading open={loading} />
      <PageContainer className='c-RcsSending'>
        <Wizard
          value={wizardStep}
          options={options}
          onChange={changeWizardStep}
        />
        <SpacingVertical variant={SPACING_24} />
        {wizardStep === 1 && <WizardStep1 />}
        {wizardStep === 2 && <WizardStep2 />}
        <SpacingVertical variant={SPACING_24} />
      </PageContainer>
    </>
  )
}

export default RcsSending
